import React from 'react';
import Divider from '@material-ui/core/Divider';

function DividerControl() {
    return <Divider orientation="vertical" flexItem />;
}

export default DividerControl;
